import { setLoginStatus } from "state/slices/loginSlice";
import { clearUsername } from "state/slices/userSlice";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate,useLocation } from "react-router-dom";
import validateToken from "./validate_api";

const TokenChecker = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const location = useLocation();
  const activeRoute = location.pathname;

  const dispatch = useDispatch();

  useEffect(() => {
    if (token) {
      validateToken(navigate, dispatch, activeRoute);
    }
  }, [token]);

  useEffect(() => {
    if (!token) {
      localStorage.clear();
      dispatch(setLoginStatus(false));
      dispatch(clearUsername());
    }
  }, [navigate, dispatch, token]);

  return null;
};

export default TokenChecker;
